import { SVGProps } from 'react';

export const Circle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="1"
      y="1"
      width="20"
      height="20"
      rx="10"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.88675 16.3873L5 11.5005L6.864 9.6365L9.88675 12.6592L15.546 7L17.41 8.864L9.88675 16.3873Z"
      fill="none"
    />
  </svg>
);
